import { getGlobal } from './get-global'; // eslint-disable-next-line no-new-func

export var isBrowser = new Function('try {return this===window;}catch(e){ return false;}');
export var isWeb = function isWeb() {
  return isBrowser() && !isKraken();
};
export var isKraken = function isKraken() {
  return typeof getGlobal().kraken !== 'undefined';
};
export var isHippy = function isHippy() {
  return typeof getGlobal().Hippy !== 'undefined';
};
export var isWebWithinOneApi = function isWebWithinOneApi() {
  return isWeb() && typeof getGlobal().OneAPI !== 'undefined';
};
export var isWebWithoutOneApi = function isWebWithoutOneApi() {
  return isWeb() && typeof getGlobal().OneAPI === 'undefined';
};
export function isNode() {
  return !!(typeof process !== 'undefined' && process.versions && process.versions.node);
}
export function getUserAgent() {
  var _window, _window$navigator;

  return typeof window !== 'undefined' ? ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) || '' : '';
}
/**
 * 获得系统信息
 */

export function getSystem() {
  if (isNode()) {
    return 'ios'; // node端按照ios标准来
  }

  var ua = getUserAgent().toLowerCase();

  if (/iphone|ipad|ipod|mac/.test(ua)) {
    return 'ios';
  }

  if (/android/.test(ua)) {
    return 'android';
  }

  return null;
}